import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Row, Container, Form, Spinner, UncontrolledAccordion } from "reactstrap";
import { Breadcrumb, BreadcrumbItem } from "reactstrap";
import { useTranslation } from "react-i18next";
import APP_ROUTES from "src/routes/routes";
import { useSetRecoilState } from "recoil";
import { navigationPromptState } from "src/recoil/atoms/global";
import { CustomLink } from "src/components/Common/CustomLink";
import { usePatchedNavigate } from "src/Hooks/usePatchedNavigate";
import { FORM_NAME } from "src/pages/Sequence/detail";
import MainSection from "../components/MainSection";
import TooltipWrapper from "src/components/Common/TooltipWrapper";

const SequenceDetailForm = ({ submitData, data, getRedirectURL = () => APP_ROUTES.SEQUENCES }) => {
  const { t } = useTranslation("sequence");
  const navigate = usePatchedNavigate();
  const [isSubmit, setIsSubmit] = useState(false);
  const navigationPrompt = useSetRecoilState(navigationPromptState);

  const {
    register,
    handleSubmit,
    formState: { errors, isDirty },
    setValue,
  } = useForm({
    defaultValues: data,
  });

  const handleSubmitForm = (formData) => {
    navigationPrompt(false);
    setIsSubmit(true);

    const dataModified = {
      ...formData,
      notes: formData?.notes?.trim() || "",
    };

    return submitData({ data: dataModified, id: data?.[FORM_NAME.MAIN.ID] }, (isSubmitFailed) => {
      setIsSubmit(false);
      isSubmitFailed && isDirty && navigationPrompt(true);
    });
  };

  useEffect(() => {
    if (isDirty) {
      navigationPrompt(true);
    }
  }, [isDirty]);

  return (
    <Container fluid className="project-instance-container">
      <Breadcrumb>
        <BreadcrumbItem>
          <CustomLink to={getRedirectURL()} className="link-primary">
            {t("list.title")}
          </CustomLink>
        </BreadcrumbItem>
        <BreadcrumbItem>{t("detail.title")}</BreadcrumbItem>
        <BreadcrumbItem active>
          <TooltipWrapper
            id={`tooltip-sequence-detail-breadcrumb`}
            tooltipText={data?.[FORM_NAME.MAIN.LINKED_INSTANCE] || ""}
            checkOverflow={true}
            tooltipClassName="max-width-by-px-300"
          >
            <span className="d-block overflow-hidden text-truncate max-width-by-px-400">
              {data?.[FORM_NAME.MAIN.LINKED_INSTANCE] || ""}
            </span>
          </TooltipWrapper>
        </BreadcrumbItem>
      </Breadcrumb>

      <Row>
        <div className="col-12">
          <div className="card">
            <div className="card-body">
              <Form onSubmit={handleSubmit(handleSubmitForm)} className="project-instance-form test-package-form">
                <UncontrolledAccordion defaultOpen={["1"]} stayOpen>
                  <MainSection
                    register={register}
                    errors={errors}
                    setValue={setValue}
                    sequenceData={data}
                    navigationPrompt={navigationPrompt}
                  />
                </UncontrolledAccordion>

                <div className="d-flex justify-content-center gap-2 mt-2">
                  <span
                    role="button"
                    className="btn btn-secondary width-by-px-200 height-by-px-38"
                    onClick={() => navigate(getRedirectURL(data?.page))}
                  >
                    <span>{t("cancel")}</span>
                  </span>
                  <button className="btn btn-primary width-by-px-200 height-by-px-38" disabled={isSubmit || !isDirty} type="submit">
                    {isSubmit ? <Spinner size="sm" /> : <span>{t("submit")}</span>}
                  </button>
                </div>
              </Form>
            </div>
          </div>
        </div>
      </Row>
    </Container>
  );
};

export default SequenceDetailForm;
